/* Карусел в хирото. Скролът е нативен със scroll-snap —
   мишка, пръст и клавиатура работят без допълнителен код.
   JS-ът само синхронизира миниатюрите. */
(function () {
  'use strict';

  function init(root) {
    var galleries = (root || document).querySelectorAll('[data-lp-gallery]');
    Array.prototype.forEach.call(galleries, function (g) {
      if (g.dataset.lpGalleryOn === '1') return;
      g.dataset.lpGalleryOn = '1';

      var track  = g.querySelector('[data-lp-gallery-track]');
      var slides = g.querySelectorAll('[data-lp-gallery-slide]');
      var thumbs = g.querySelectorAll('[data-lp-gallery-thumb]');
      if (!track || slides.length < 2) return;

      function setActive(i) {
        Array.prototype.forEach.call(thumbs, function (t) {
          var on = parseInt(t.dataset.lpGalleryThumb, 10) === i;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
        });
      }

      Array.prototype.forEach.call(thumbs, function (t) {
        t.addEventListener('click', function () {
          var i = parseInt(t.dataset.lpGalleryThumb, 10);
          track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: 'smooth' });
          setActive(i);
        });
      });

      // Коя снимка се вижда в момента — по позицията на скрола.
      var ticking = false;
      track.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          var i = Math.round(track.scrollLeft / track.clientWidth);
          if (i >= 0 && i < slides.length) setActive(i);
          ticking = false;
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
